<template>
  <div class="graphic-photos-content" id="identidade-visual-grafismos-aplicacoes" data-search-anchor>
    <div class="title-graphic-photos-wrapper">
      <h1 class="graphic-photos-title-span">{{ graphicAplicacaoTitleSpan }}</h1>
      <h1 class="graphic-photos-title">{{ graphicAplicacaoTitle }}</h1>
    </div>
    <div class="graphic-photos-card-item" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>    
    <div class="graphic-photos-card-item" :style="{ backgroundImage: `url(${ImageSrc2})` }" style="margin-top: 1rem; margin-bottom: 2rem;"></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class GraphicsPhotosSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  get graphicAplicacaoTitleSpan(): string {
    return this.getElementTitle(9, 0)
  }

  get graphicAplicacaoTitle(): string {
    return this.getElementText(9, 0)
  }

  get ImageSrc(): string {
    return this.getElementMedia(9, 0)
  }

  get ImageSrc2(): string {
    return this.getElementMedia(9, 1)
  }  

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-photos-content {
  display: grid;
  max-width: 1032px;
}

.graphic-photos-card-item {
  position: relative;
  width: 1032px;
  height: 525px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.title-graphic-photos-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.graphic-photos-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.graphic-photos-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}
</style>
